<template>
      <v-img
        :src="require('@/assets/background.svg')"
        cover
        :max-width="'100%'"
        :max-height="'100vh'"
        position='top center'
      >
    <v-navigation-drawer
      fixed
      absolute
      app
      v-model="drawer"
      class="grey lighten-4"
    >
      <v-layout column fill-height>
          <v-list two-line>
          <v-list-tile v-if="user" class="pt-4">
              <v-layout align-center justify-center column >
              Vendendo como:
                <v-chip color="accent" dark close @input="sair">
                  {{ formatarEmail(user.email) }}
                </v-chip>
              </v-layout>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <div class="scroll-y" style="max-height: calc(100% - 130px)">
          <v-list dense>
            <template v-for="item in items">
              <v-list-tile :key="item.text" ripple @click="$router.push(item.route)">
                <v-list-tile-action>
                  <v-icon color="grey">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </div>
      </v-layout>
    </v-navigation-drawer>
    <v-toolbar
      color="#eee"
      app
      fixed
      class="elevation-0"
    >
      <v-badge color="primary" overlap v-if="user">
        <v-icon
          slot="badge"
          dark
          small
        >menu</v-icon>
        <v-btn flat icon dark class="ma-0" @click.stop="drawer = !drawer">
          <v-avatar
            color="grey"
            size="30">
            <img v-if="user.image" :src="user.image" alt="trevor">
            <v-icon dark v-else>face</v-icon>
          </v-avatar>
        </v-btn>
      </v-badge>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <span class="hidden-sm-and-down">Sua apetrus</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template>
      <v-chip v-if="posto" @input="closePosto" close text-color="white" color="primary">{{posto.nome_fantasia}}</v-chip>
      <v-tooltip bottom v-if="smartLockAtivo">
        <v-btn flat icon dark class="red" slot="activator" @click="authenticationDialog = true" v-if="!smartLock">
          <v-icon size="19">lock</v-icon>
        </v-btn>
        <v-btn round dark class="green" slot="activator" @click="restoreTime" v-else>
          <v-spacer></v-spacer>
          {{formatedTimer}}
          <v-spacer></v-spacer>
          <v-icon size="19" class="pl-2">lock_open</v-icon>
        </v-btn>
        Smart Lock
      </v-tooltip>
      </template>
    </v-toolbar>
    <v-content style="height: 100%">
      <v-alert
        v-if="posto && posto.is_white_label && !posto.provedor_smtp"
        :value="true"
        type="error"
        class="pa-1"
      >
        <v-layout>
          <div class="mt-2">Você precisa cadastrar um provedor de envio de e-mail</div>
          <v-spacer></v-spacer>
          <v-btn small @click="$router.push('/falecomcliente')">Ir para Cadastro</v-btn>
        </v-layout>
      </v-alert>
      <v-layout column justify-center align-center v-if="!smartLock && smartLockAtivo" class="pa-4">
        <v-flex class="text-xs-center headline primary--text text-xs-center">
          Acesso bloqueado através do SmartLock
        </v-flex>
        <v-flex class="subheading text-xs-center grey--text text--darken-2 font-weight-medium">
            Clique no cadeado ao canto superior direito da tela para desbloquear
        </v-flex>
      </v-layout>
      <div
        v-else
        id="scrolling-techniques"
        class="scroll-y"
        style="max-height: calc(100vh - 64px);"
      >
        <router-view></router-view>
      </div>
    </v-content>
    <v-dialog :value="dialogPostos" scrollable persistent max-width="300px">
      <postos-select
        v-on:postoSelected="postoSelected"
        @success="snackbarSuccess"
        @error="snackbarError"
      ></postos-select>
    </v-dialog>
    <v-dialog :value="dialogCad" lazy persistent max-width="500px">
      <app-inicio-posto v-if="dialogCad"></app-inicio-posto>
    </v-dialog>
    <v-dialog v-model="dialogVersoes" width="500">
      <versoes></versoes>
    </v-dialog>
    <v-dialog :value="!user" width="500" persistent>
      <usuario-nao-logado></usuario-nao-logado>
    </v-dialog>
    <v-dialog v-model="authenticationDialog" width="350" lazy>
      <autenticar-smart-lock @erro="erroSmartLock" @fechar="authenticationDialog = false" @autenticado="authenticationDialog = false"></autenticar-smart-lock>
    </v-dialog>
    <v-dialog v-model="dialogAtualizacaoPag" width="500" lazy>
      <dialog-atualizacao-pagina  @fechar="dialogAtualizacaoPag = false"/>
    </v-dialog>
    <v-dialog v-model="dialogUpdate" width="500" lazy persistent>
      <dialog-update-version  @fechar="dialogUpdate = false"/>
    </v-dialog>
    <v-dialog v-model="mostrarDialog"  width="500">
      <dialog-tem-transferencias @fechar="mostrarDialog = false"/>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.ativo"
      :color="snackbar.color"
      :timeout="4000"
      :vertical="true"
    >
      {{snackbar.text}}
      <v-spacer></v-spacer>
      <v-btn @click="snackbar.active = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-img>
</template>

<script>
import UsuarioNaoLogado from '@/components/dialogs/UsuarioNaoLogado'
import PostosSelect from '@/components/dialogs/PostosSelect'
import AppInicioPosto from '@/components/dialogs/DialogInicioPosto'
import Versoes from '@/components/dialogs/Versoes'
import AutenticarSmartLock from '@/components/dialogs/AutenticarSmartLock'
import DialogAtualizacaoPagina from '@/components/dialogs/DialogAtualizacaoPagina'
import DialogTemTransferencias from '@/components/dialogs/DialogTemTransferencias'
import moment from 'moment'
import { version, name } from '../../../package.json'

export default {
  name: 'App',
  components: { PostosSelect, AppInicioPosto, Versoes, UsuarioNaoLogado, AutenticarSmartLock, DialogAtualizacaoPagina, DialogTemTransferencias },
  data: () => ({
    drawer: false,
    snackbar: {
      ativo: false,
      color: 'info',
      text: ''
    },
    dialogEditPosto: false,
    dialogAtualizacaoPag: false,
    dialogVersoes: false,
    mostrarDialog: false,
    authenticationDialog: false,
    interval: null,
    dialogUpdate: false,
    newWorker: null,
    items: [
      { icon: 'home', text: 'Inicio', route: '/home' },
      { icon: 'contacts', text: 'Frentistas', route: '/frentistas' },
      { icon: 'local_gas_station', text: 'Meus Postos', route: '/postos' },
      { icon: 'account_balance_wallet', text: 'Carteira Apetrus', route: '/carteiravirtual' },
      { icon: 'ac_unit', text: 'Minhas Redes', route: '/minhasredes' },
      { icon: 'autorenew', text: 'Minhas Faturas', route: '/faturas' },
      { icon: 'attach_money', text: 'Meu Faturamento', route: '/meufaturamento' },
      { icon: 'people', text: 'Meus Convênios', route: 'convenios' },
      { icon: 'forum', text: 'Negociações', route: '/propostas' },
      { icon: 'attach_money', text: 'Meios de Recebimento', route: '/meiosderecebimento' },
      { icon: 'insert_drive_file', text: 'Relatórios', route: '/relatorio' },
      { icon: 'people', text: 'Meus Clientes', route: '/meusclientes' },
      { icon: 'thumbs_up_down', text: 'Consolidação', route: '/consolidar' },
      { icon: 'border_color', text: 'Editar dados do Posto', route: '/editarposto' },
      { icon: 'border_color', text: 'Editar Perfil', route: '/editarperfil' },
      { icon: 'email', text: 'Fale com o Cliente', route: '/falecomcliente' },
      { icon: 'chat_bubble', text: 'Fale com a Apetrus', route: '/contato' },
      { icon: 'help', text: 'Ajuda', route: '/faq' },
      { icon: 'settings', text: 'Configurações', route: '/configuracoes' }
    ]
  }),
  props: {
    source: String
  },
  watch: {
    drawer (val) {
      this.$store.commit('setDrawer', val)
    },
    versao (val) {
      this.$store.dispatch('verificarAtualizacao', {
        name: name,
        version: val
      })
    },
    dialogTransferencia (val) {
      if (val) {
        this.mostrarDialog = true
        this.$router.push('/postos')
        this.$store.dispatch('addTimer')
      }
    },
    headers (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('carregarCombustiveis')
        this.$store.dispatch('carregarVersoes')
        this.$store.dispatch('pegarRedes')
        this.$store.dispatch('solicitacoesDeTransferencia')
      }
    },
    user (val) {
      if (val === null) {
        this.$router.push('/')
      }
    },
    versoesReady (val) {
      if (val) {
        this.dialogVersoes = true
      }
    },
    dialogVersoes (val, oldval) {
      if (!val && oldval) {
        this.$store.dispatch('lerVersoes')
      }
    }
  },
  created () {
    this.$store.dispatch('verificarAtualizacao', {
      name: name,
      version: version
    })
    window.addEventListener('keydown', (e) => {
      if (this.smartLock && ((e.ctrlKey && e.keyCode === 82) || e.keyCode === 116)) {
        e.preventDefault()
        this.dialogAtualizacaoPag = true
      }
    })
  },
  mounted () {
    if (this.headers) {
      this.$store.dispatch('pegarRedes')
      this.$store.dispatch('carregarCombustiveis')
      this.$store.dispatch('carregarVersoes')
      this.$store.dispatch('solicitacoesDeTransferencia')
    }
  },
  computed: {
    formatedTimer () {
      let duration = moment.duration(this.timer, 'seconds')
      let tempHours = duration.hours()
      let tempMinutes = duration.minutes() < 10 ? `0${duration.minutes()}` : duration.minutes()
      let tempSeconds = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds()
      return `${tempHours}:${tempMinutes}:${tempSeconds}`
    },
    timer () {
      return this.$store.getters.timer
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    headers () {
      return this.$store.getters.headers
    },
    user () {
      return this.$store.getters.user
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    posto () {
      return this.$store.getters.posto
    },
    postos () {
      return this.$store.getters.postos
    },
    redes () {
      return this.$store.getters.redes
    },
    pessoa () {
      return this.$store.getters.pessoa
    },
    solicitacoes_transferencia () {
      return this.$store.getters.solicitacoes_transferencia
    },
    dialogPostos () {
      return this.user && this.postos && this.postos.length && !this.posto
    },
    dialogCad () {
      return this.user && ((this.postos && this.postos.length === 0 && this.solicitacoes_transferencia && this.solicitacoes_transferencia.length === 0) || (this.posto && (!this.posto.geoposition || !this.posto.precificado)) || (this.posto && !this.posto.termos_aceitos))
    },
    dialogTransferencia () {
      return this.solicitacoes_transferencia !== null && this.solicitacoes_transferencia.length > 0
    },
    versoes () {
      return this.$store.getters.versoes
    },
    versoesReady () {
      return this.user && !!this.versoes.length && this.posto
    },
    hasNewVersion () {
      return this.$store.getters.hasNewVersion
    },
    versao () {
      return this.$store.getters.versao
    },
    updateVersion () {
      return this.$store.getters.versao !== version
    },
    smartLockAtivo () {
      const pessoa = this.$store.getters.pessoa
      if (pessoa) {
        return pessoa.smartlock_posto
      } else {
        return false
      }
    }
  },
  methods: {
    formatarEmail (email) {
      const limiteCaracteres = 25
      if (email.length > limiteCaracteres) {
        return email.slice(0, limiteCaracteres) + '...'
      }
      return email
    },
    snackbarSuccess (text) {
      this.snackbar.color = 'info'
      this.snackbar.text = text
      this.snackbar.ativo = true
    },
    snackbarError (erro) {
      this.smartLockDialog = false
      this.snackbar.color = 'error'
      this.snackbar.text = erro
      this.snackbar.ativo = true
    },
    erroSmartLock (erro) {
      this.smartLockDialog = false
      this.snackbar.color = 'error'
      this.snackbar.text = erro
      this.snackbar.ativo = true
    },
    erroAuthentication (erro) {
      this.authenticationDialog = false
      this.snackbar.color = 'error'
      this.snackbar.text = erro
      this.snackbar.ativo = true
    },
    saveEvent () {
      this.$store.dispatch('createEvent', this.event)
    },
    sair () {
      this.$store.dispatch('signUserOut')
    },
    postoSelected (posto) {
      this.$store.dispatch('escolherPosto', posto)
    },
    closePosto () {
      this.$store.dispatch('unselectPosto')
    },
    closeUpdate () {
      this.dialogEditPosto = false
    },
    restoreTime () {
      this.$store.dispatch('restoreTimer')
    }
  }
}
</script>

<style>
  .v-responsive__content {
    max-width: 100% !important
  }

  @media screen {
    .hide-display {
      display: none;
    }
  }

  @media print {

    /* Inhaltsbreite setzen, Floats und Margins aufheben */
    /* Achtung: Die Klassen und IDs variieren von Theme zu Theme. Hier also eigene Klassen setzen */
    #content, #page {
      width: 100%;
      margin: 0;
      float: none;
    }

    /** Seitenränder einstellen */
    @page { margin: 1cm }

    /* Font auf 16px/13pt setzen, Background auf Weiß und Schrift auf Schwarz setzen.*/
    /* Das spart Tinte */
    body {
      font: 13pt Georgia, "Times New Roman", Times, serif;
      line-height: 1.3;
      background: #fff !important;
      color: #000;
    }

    body * {
      visibility: hidden;
      margin: 0;
    }

    .print {
      visibility: visible;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      max-width: 100%;
    }

    .print * {
      max-width: 100%;
      visibility: visible;
    }

    h1 {
      font-size: 24pt;
    }

    h2, h3, h4 {
    font-size: 14pt;
    margin-top: 25px;
    }

    /* Alle Seitenumbrüche definieren */
    a {
        page-break-inside:avoid
    }
    blockquote {
        page-break-inside: avoid;
    }
    h1, h2, h3, h4, h5, h6 { page-break-after:avoid;
        page-break-inside:avoid }
    img { page-break-inside:avoid;
        page-break-after:avoid; }
    table, pre { page-break-inside:avoid }
    ul, ol, dl  { page-break-before:avoid }

    /* Linkfarbe und Linkverhalten darstellen */
    a:link, a:visited, a {
    background: transparent;
    color: #520;
    font-weight: bold;
    text-decoration: underline;
    text-align: left;
    }

    a {
        page-break-inside:avoid
    }

    a[href^=http]:after {
          content:" <" attr(href) "> ";
    }

    a:after > img {
      content: "";
    }

    article a[href^="#"]:after {
      content: "";
    }

    a:not(:local-link):after {
      content:" <" attr(href) "> ";
    }

    /**
    * Eingebundene Videos verschwinden lassen und den Whitespace der iframes auf null reduzieren.
    */
    .entry iframe, ins {
        display: none;
        width: 0 !important;
        height: 0 !important;
        overflow: hidden !important;
        line-height: 0pt !important;
        white-space: nowrap;
    }
    .embed-youtube, .embed-responsive {
      position: absolute;
      height: 0;
      overflow: hidden;
    }

    /* Unnötige Elemente ausblenden für den Druck */

    #header-widgets, nav, aside.mashsb-container,
    .sidebar, .mashshare-top, .mashshare-bottom,
    .content-ads, .make-comment, .author-bio,
    .heading, .related-posts, #decomments-form-add-comment,
    #breadcrumbs, #footer, .post-byline, .meta-single,
    .site-title img, .post-tags, .readability
    {
    display: none;
    }

    /* Benutzerdefinierte Nachrichten vor und nach dem Inhalt einfügen */
    .entry:after {
    content: "\ Alle Rechte vorbehalten. (c) 2014 - 2016 TechBrain - techbrain.de";
    color: #999 !important;
    font-size: 1em;
    padding-top: 30px;
    }
    #header:before {
    content: "\ Vielen herzlichen Dank für das Ausdrucken unseres Artikels. Wir hoffen, dass auch andere Artikel von uns Ihr Interesse wecken können.";
    color: #777 !important;
    font-size: 1em;
    padding-top: 30px;
    text-align: center !important;
    }

    /* Wichtige Elemente definieren */
    p, address, li, dt, dd, blockquote {
    font-size: 100%
    }

    /* Zeichensatz fuer Code Beispiele */
    code, pre { font-family: "Courier New", Courier, mono}

    ul, ol {
    list-style: square; margin-left: 18pt;
    margin-bottom: 20pt;
    }

    li {
    line-height: 1.6em;
    }

  }

</style>
